export default __webpack_public_path__ + "static/media/vip_bg_card_blue.a17c76b1.png";